import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import extend from 'lodash/extend';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import Slug from '../../../components/slug/slug';
import VideoModule from '../../../components/video_module/video_module';
import AllFeed from '../../../components/all_feed/all_feed';
import Advertorial, { isAdvertorial } from '../../../components/advertorial/advertorial';
import { tagAllFeedAllStoriesRendered } from '../../../../redux/action_creators/tag_all_feed_action_creators';

// eslint-disable-next-line react/prefer-stateless-function
class Tag extends Component {
  render() {
    const {
      config,
      tagPage,
      tagVideo,
      tagFeaturedFeed,
      tagAllFeed
    } = this.props;
    if (tagPage.error || tagFeaturedFeed.error) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (tagPage.isLoading) {
      return (
        <section className="tag-page">
          <article className="tag-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const adData = get(tagPage, 'ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );

    const pgName = 'Crossover To A Smarter Life Presented By Kia Niro';
    const pgDesc = get(tagFeaturedFeed, 'tag.description');
    const tags = get(tagAllFeed, 'posts[0].tags');
    const advertorial = isAdvertorial(tags);
    const currentSite = get(config, 'site');

    return (
      <section
        className={`tag-page tag-page--kia ${advertorial
          ? 'tag-page--advertorial'
          : ''}`}
      >
        <a href="https://www.kia.com/niro">
          <img
            className="kia-banner"
            alt="Kia"
            src="https://assets.fastcompany.com/image/upload/w_1280,q_auto,f_auto,fl_lossy/v1491257339/fcweb/kia_full_screen_banner_v5.jpg"
          />
        </a>

        {advertorial
          ? <Advertorial
              modifier="tag-page"
              tags={tags}
              adModel={combinedAdModel}
            />
          : ''}

        {advertorial
          ? <section className="all-feed">
              <Slug slugName={pgName} className="tag-page" />
              <h3 className="page-description">{pgDesc}</h3>
              <AllFeed
                adModel={combinedAdModel}
                modifier="advertorial"
                stories={get(tagAllFeed, 'posts')}
                allRendered={get(tagAllFeed, 'allRendered')}
                updateAction={tagAllFeedAllStoriesRendered}
                currentSite={currentSite}
              />
            </section>
          : <div>
              <VideoModule
                slugName="CROSSOVER TO A SMARTER LIFE PRESENTED BY KIA NIRO"
                data={tagVideo}
                playerid="xb9OmFp1"
                stories={tagVideo.playlist}
                currentSite={currentSite}
              />
              {get(tagFeaturedFeed, 'top.length')
                ? <div className="tag-page__ff-ad-container">
                    <Ad {...combinedAdModel} name="flexiblebillboard_2" />
                    <Ad {...combinedAdModel} name="mobilerectangle_1" />
                  </div>
                : ''}
              <AllFeed
                adModel={combinedAdModel}
                stories={get(tagAllFeed, 'posts')}
                allRendered={get(tagAllFeed, 'allRendered')}
                updateAction={tagAllFeedAllStoriesRendered}
                currentSite={currentSite}
              />
            </div>}

        {get(tagVideo, 'playlist.length')
          ? <div className="tag-page__video-ad-container">
              <Ad {...combinedAdModel} name="flexiblebillboard_3" />
              <Ad {...combinedAdModel} name="mobilerectangle_2" />
            </div>
          : ''}
        <div
          dangerouslySetInnerHTML={{
            __html:
              '<script type="text/javascript">/* <![CDATA[ */ var google_conversion_id = 972240864; var google_custom_params = window.google_tag_params; var google_remarketing_only = true; /* ]]> */</script><script type="text/javascript" src="//www.googleadservices.com/pagead/conversion.js"></script><noscript><div style="display:inline;"><img height="1" width="1" style="border-style:none;" alt="" src="//googleads.g.doubleclick.net/pagead/viewthroughconversion/972240864/?guid=ON&amp;script=0"/></div></noscript>'
          }}
        />
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    tagFeaturedFeed: {
      featured: get(state, 'tagFeaturedFeed.featured') || [],
      top: get(state, 'tagFeaturedFeed.top') || [],
      tag: get(state, 'tagFeaturedFeed.tag') || {},
      source: get(state, 'tagFeaturedFeed.source') || '',
      error: get(state, 'tagFeaturedFeed.error') || false
    },
    tagVideo: get(state, 'tagVideo.data') || {
      playlist: [],
      title: '',
      feedid: ''
    },
    tagPage: get(state, 'tagPage') || { error: true },
    tagScrollingModule: get(state, 'tagScrollingModule.data.posts') || [],
    tagAllFeed: {
      allRendered: get(state, 'tagAllFeed.allRendered') || false,
      posts: get(state, 'tagAllFeed.data') || []
    }
  };
}

Tag.propTypes = {
  config: PropTypes.shape({}).isRequired,
  tagPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  tagFeaturedFeed: PropTypes.shape({
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({})),
    tag: PropTypes.object,
    source: PropTypes.string,
    error: PropTypes.bool
  }).isRequired,
  tagVideo: PropTypes.shape({
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    feedid: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  tagAllFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool
  }).isRequired
};

export default connect(mapStateToProps)(Tag);



// WEBPACK FOOTER //
// ./src/views/containers/pages/tag_page/sponsored_kia_tag_page.js